var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWlan = function SvgWlan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 19.1",
    style: {
      enableBackground: "new 0 0 24 19.1"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 7c-.3 0-.6-.1-.8-.3C19.7 3.7 15.9 2 12 2 8.1 2 4.3 3.7 1.8 6.7c-.4.4-1 .5-1.4.1s-.5-1-.1-1.4C3.2 2 7.5 0 12 0c4.5 0 8.8 2 11.8 5.4.3.4.3 1.1-.2 1.4-.2.1-.4.2-.6.2zM7 12.4c-.6 0-1-.4-1-1 0-.2.1-.5.2-.6C7.7 9 9.8 8 12 8c2.2 0 4.4 1 5.8 2.7.3.4.2 1.1-.2 1.4-.4.3-1 .2-1.3-.1-1.1-1.3-2.6-2-4.3-2-1.7 0-3.2.7-4.3 2-.2.2-.4.3-.7.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1 9.6c-.3 0-.6-.1-.8-.4C17.5 7 14.8 5.8 12 5.8S6.5 7 4.7 9.2c-.3.5-1 .6-1.4.3-.5-.3-.6-.9-.2-1.4l.1-.1C5.4 5.4 8.6 3.9 12 3.9c3.4 0 6.6 1.5 8.9 4.1.4.4.3 1.1-.1 1.4-.2.2-.5.3-.7.2zM12 19.1c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zm0-5c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5c0-.9-.7-1.5-1.5-1.5z"
  })));
};
export default SvgWlan;